import { RouteConfig } from 'vue-router'
import { requireAuthAndLocation } from '../../auth'

const Subscriptions = () => import('@/pmd/pages/payments/v2/Subscriptions.vue')
const SubscriptionDetails = () => import('@/pmd/pages/payments/v2/SubscriptionDetails.vue')

export const SubscriptionsRoute: RouteConfig[] = [
  {
    path: 'payments/v2/subscriptions',
    name: 'subscriptions-v2',
    component: Subscriptions,
    beforeEnter: requireAuthAndLocation,
    children: [],
  },
  {
    path: 'payments/v2/subscriptions/:id',
    name: 'subscription-details-v2',
    component: SubscriptionDetails,
    beforeEnter: requireAuthAndLocation,
    children: [],
  },
]
